import React from 'react';
import { Inventory2Outlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { motion } from 'framer-motion';

function ItemReplacementVisual({ item, label, color, direction }) {
    const imageUrl = item?.images?.[0]?.presigned_url;

    return (
        <motion.div
            initial={{ opacity: 0, x: direction === 'left' ? '-12%' : '12%' }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
            <Stack spacing={0.75} alignItems='center'>
                <Stack alignItems='center' justifyContent='center' sx={{ width: '100%', aspectRatio: '3 / 2', backgroundColor: '#F1F3F6', borderRadius: 1, overflow: 'hidden' }}>
                    { imageUrl ?
                        <img src={imageUrl} alt={item.name ?? label} style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> :
                        <Inventory2Outlined sx={{ color: '#A5AFBD', fontSize: 36 }} />
                    }
                </Stack>
                <Typography variant='heavy' sx={{ color, fontSize: '12px' }}>{label}</Typography>
            </Stack>
        </motion.div>
    );
}

export default ItemReplacementVisual;
